export default {
    init() {
      // JavaScript to be fired on the contact page
    },
};
